module.exports = __webpack_public_path__ + "static/media/account-image-7.0de7a211.jpg";